import { createMarkup } from "../../helpers";

const Table4 = ({ values }) => {
  return (
    <table className="approved assigned">
      <thead>
        <tr>
          <th colSpan="2" className="hdg">
            Admin Fields
          </th>
        </tr>
      </thead>

      <tbody>
        {values.map((item, index) => {
          return (
            item.key !== "Last Updated" && (
              <tr key={index}>
                <th className="right top" style={{ width: "25%" }}>
                  {item.key}
                </th>
                <td
                  className="left"
                  dangerouslySetInnerHTML={createMarkup(item.value)}
                />
              </tr>
            )
          );
        })}
      </tbody>
    </table>
  );
};

export default Table4;
